import styled from 'styled-components';
import { PlayFeedWrapper, PlayFeedList, InningHeader } from '../PlayFeed/PlayFeed.style';
import { LiveFeedPlaysWrapper } from './liveFeed/LiveFeedPlays.style';
export const LiveFeedWrapper = styled(PlayFeedWrapper)`
  margin-top: 16px;
`;

export const LiveFeedList = styled(PlayFeedList)`
    ${LiveFeedPlaysWrapper} {
        &:last-child
            > div {
                &:last-child {
                    > div {
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }

    ${({ $hasList }) => {
        if ($hasList) {
            return `
          &&& {
            padding-top:8px !important;
          }
        `;
        }
    }}

    ${InningHeader} {
        margin-left: -50px;
        background-color: var(--gameday-background-color);
        position: relative;
        &:before {
            z-index: -1;
            background-color: var(--gameday-background-color);
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            top: 0px;
            left: 0px;
        }
    }
    ${({ reverse }) => reverse
    ? `
        ${InningHeader} {
            &:nth-child(1), &:nth-child(2) {
                display: none;
            }
        }
    `
    : ''}
`;
